<template>
  <div
    :class="
      isHoverEnable && visibleAvatars.length > 0
        ? 'people-button'
        : 'no-hover-people-button'
    "
    @click="handleClick"
  >
    <template v-for="(avatar, index) in visibleAvatars">
      <div :class="`people-img-up-${index}`">
        <EXTooltip
          v-if="isShowTooltip"
          placement="top"
          :title="`${avatar.firstName} ${avatar.lastName}`"
          :description="allowDrillDown ? 'Click to drilldown' : ''"
          :delay="100"
        >
          <ExAvatar
            :size="size"
            :picture="avatar.img"
            :firstName="avatar.firstName"
            :lastName="avatar.lastName"
            :class="`img-${index}`"
            class="people-image-down"
          />
        </EXTooltip>
        <ExAvatar
          v-else
          :size="size"
          :picture="avatar.img"
          :firstName="avatar.firstName"
          :lastName="avatar.lastName"
          :class="`img-${index}`"
          class="people-image-down"
        />
      </div>
    </template>
    <span
      v-if="hiddenCount > 0"
      :class="`people-extra-people-1 people-extra-people-1-${size}`"
    >
      <EXTooltip
        v-if="isShowTooltip"
        placement="top"
        :title="hiddenAvatarsNames"
        :description="allowDrillDown ? 'Click to drilldown' : ''"
        :delay="100"
      >
        <span class="people-extra-people"> +{{ hiddenCount }} </span>
      </EXTooltip>
      <span v-else class="people-extra-people"> +{{ hiddenCount }} </span>
    </span>
  </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from "vue";
import { useRouter } from "vue-router";
import ExAvatar from "@components/common/ExAvatar.vue";
import EXTooltip from "@components/tooltip/EXTooltip.vue";

const props = defineProps({
  avatars: {
    type: Array,
    default: () => [],
  },
  maxVisible: {
    type: Number,
    default: 3,
  },
  size: {
    type: String,
    default: "large",
  },
  isHoverEnable: {
    type: Boolean,
    default: true,
  },
  isShowTooltip: {
    type: Boolean,
    default: false,
  },
  isMasterRes: {
    type: Boolean,
    default: false,
  },
  resId: {
    type: Number,
    default: null,
  },
  allowDrillDown: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(["onAvatarClick"]);

const visibleAvatars = computed(() => {
  return props.avatars.slice(0, props.maxVisible);
});

const hiddenCount = computed(() => {
  return props.avatars.length - props.maxVisible;
});

const hiddenAvatars = computed(() => {
  return props.avatars.slice(props.maxVisible);
});

const hiddenAvatarsNames = computed(() => {
  return hiddenAvatars.value
    .map((avatar) => `${avatar.firstName} ${avatar.lastName}`)
    .join(", ");
});

const handleClick = () => {
  if (props.isMasterRes) {
    const router = useRouter();
    router.push(
      `/my-stuff/master/responsibilities/${props.resId}?defaultFilter=coach`
    );
  } else {
    emit("onAvatarClick");
  }
};
</script>

<style scoped>
.no-hover-people-button {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
}
.people-button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  /* padding: 10px 9px 10px 9px; */
  left: -6px;
  cursor: pointer;
}
.people-extra-people-1 {
  z-index: 1;
  border: 4px solid #fff;
  border-radius: 50%;
  margin-left: -14px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f0f0f0;
  color: #7F56D9;
  font-family: Inter;
  font-weight: 600;
  font-style: Semi Bold;
  font-size: 14px;
  line-height: 14.4px;
  text-align: center;
  transition: all 0.2s ease-in-out;
}

.people-extra-people-1:hover {
  border: 4px solid #E4DBFC;
  box-shadow: 0px 4px 4px 0px #0000000D;
  cursor: url("../assets/cursorArrow.svg"), auto;
  transform: scale(1.1);
  z-index: 2;
}

.people-extra-people-1-small {
  width: 33px;
  height: 33px;
}
.people-extra-people-1-normal {
  width: 38px;
  height: 38px;
}
.people-extra-people-1-medium {
  width: 42px;
  height: 42px;
}
.people-extra-people-1-large {
  width: 50px;
  height: 50px;
}
.people-img-up-0 {
  border: 4px solid white;
  border-radius: 50%;
  transition: all 0.2s ease-in-out;
  position: relative;
}
.people-img-up-0:hover {
  border: 4px solid #E4DBFC;
  box-shadow: 0px 4px 4px 0px #0000000D;
  cursor: url("../assets/cursorArrow.svg"), auto;
  transform: scale(1.1);
  z-index: 2;
}
.people-img-up-1 {
  margin-left: -14px;
  border: 4px solid white;
  border-radius: 50%;
  z-index: 1;
  transition: all 0.2s ease-in-out;
  position: relative;
}
.people-img-up-1:hover {
  border: 4px solid #E4DBFC;
  box-shadow: 0px 4px 4px 0px #0000000D;
  cursor: url("../assets/cursorArrow.svg"), auto;
  transform: scale(1.1);
  z-index: 2;
}
.people-img-up-2 {
  margin-left: -14px;
  border: 4px solid white;
  border-radius: 50%;
  z-index: 1;
  transition: all 0.2s ease-in-out;
  position: relative;
}
.people-img-up-2:hover {
  border: 4px solid #E4DBFC;
  box-shadow: 0px 4px 4px 0px #0000000D;
  cursor: url("../assets/cursorArrow.svg"), auto;
  transform: scale(1.1);
  z-index: 2;
}
</style>
